import React from "react";

const AchievementsAnimation = () => {
  return (
    <section className="d2-achievements" id="achievements" aria-labelledby="achievements-title">
      <div className="d2-container">
        <span className="section-label reveal">Milestones</span>
        <h2 className="section-title reveal reveal-delay-1" id="achievements-title">Achievements</h2>
        <div className="achievements-grid">
          <div className="achievement-card reveal">
            <div className="achievement-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2" />
                <path d="M18 14h-8" /><path d="M15 18h-5" /><path d="M10 6h8v4h-8V6Z" />
              </svg>
            </div>
            <div>
              <div className="achievement-date">15 September 2021</div>
              <div className="achievement-title">Featured in Newspaper</div>
              <p className="achievement-desc">
                Featured in FirstIndia newspaper on Engineer's Day, under the title <em>'Magicians with tools'</em>.
              </p>
              <a href="https://firstindia.co.in/article-view/jaipur/15092021/32555" target="_blank" rel="noopener noreferrer" className="achievement-link">
                Read article
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M7 17 17 7M7 7h10v10" />
                </svg>
              </a>
            </div>
          </div>
          <div className="achievement-card reveal reveal-delay-1">
            <div className="achievement-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="8" r="6" /><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11" />
              </svg>
            </div>
            <div>
              <div className="achievement-date">March 2016</div>
              <div className="achievement-title">National Level Winner — Android Championship</div>
              <p className="achievement-desc">
                Secured first position (National Level) in the final round of Android Championship, Utkraanti in association with Chemclave'16 IIT Madras, organised by Wingfotech Excellence.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AchievementsAnimation;
